{
  "draft": {
    "name": "Draft",
    "action": null,
    "allowed": ["ready"],
    "comment": "Stworzenie zgłoszenia",
    "editable": true,
    "sendable": false
  },
  "ready": {
    "name": "Edycja",
    "action": null,
    "allowed": ["draft", "confirmed", "ready"],
    "comment": "Zapisanie wersji roboczej",
    "editable": true,
    "sendable": false
  },
  "confirmed": {
    "name": "Nowe",
    "action": "Zgłoszenie gotowe do wysłania",
    "allowed": ["ready", "sending", "sending-problem", "sending-failed", "confirmed-waiting", "archived"],
    "comment": "Zapisanie gotowego zgłoszenia",
    "editable": true,
    "sendable": true
  },
  "sending": {
    "name": "Wysyłam",
    "action": null,
    "allowed": ["sending-problem", "sending-failed", "confirmed-waiting", "archived"],
    "comment": "Wysyłka w trakcie",
    "editable": false,
    "sendable": false
  },
  "sending-problem": {
    "name": "Problem z wysyłką",
    "action": null,
    "allowed": ["sending-failed", "confirmed-waiting", "archived"],
    "comment": "Tymczasowy problem z wysyłką",
    "editable": false,
    "sendable": false
  },
  "sending-failed": {
    "name": "Niewysłane",
    "action": null,
    "allowed": ["sending", "sending-problem", "confirmed-waiting", "archived"],
    "comment": "Nie udało się wysłać wiadomości",
    "editable": false,
    "sendable": true
  },
  "confirmed-waiting": {
    "name": "Wysłane",
    "action": "Zgłoszenie zostało wysłane",
    "allowed": ["confirmed-sm", "confirmed-fined", "confirmed-instructed", "confirmed-ignored", "archived"],
    "comment": "Wysłanie zgłoszenia",
    "editable": false,
    "sendable": false
  },
  "confirmed-waitingE": {
    "name": "Wysłane epuap",
    "action": "Zgłoszenie zostało wysłane przez EPUAP",
    "allowed": ["confirmed-sm", "confirmed-fined", "confirmed-instructed", "confirmed-ignored", "archived"],
    "comment": "Wysłanie zgłoszenia za pomocą EPUAP",
    "editable": false,
    "sendable": false
  },
  "confirmed-sm": {
    "name": "Potwierdzone",
    "action": "Zgłoszenie zostało potwierdzone",
    "allowed": ["confirmed-fined", "confirmed-instructed", "confirmed-ignored", "archived"],
    "comment": "Potwierdzenie przyjęcia zgłoszenia przez/w SM",
    "editable": false,
    "sendable": false
  },
  "confirmed-fined": {
    "name": "Mandat",
    "action": "Kierowca dostał mandat",
    "recydywa": "Kierowca tego pojazdu został ukarany mandatem",
    "allowed": ["confirmed-instructed", "confirmed-ignored", "confirmed-sm", "archived"],
    "comment": "Kierowca został ukarany mandatem",
    "editable": false,
    "sendable": false
  },
  "confirmed-instructed": {
    "name": "Pouczenie",
    "action": "Kierowca został pouczony",
    "recydywa": "Kierowca tego pojazdu został pouczony",
    "allowed": ["confirmed-fined", "confirmed-ignored", "confirmed-complaint", "confirmed-sm", "archived"],
    "comment": "Kierowca został pouczony",
    "editable": false,
    "sendable": false
  },
  "confirmed-ignored": {
    "name": "Zignorowane",
    "action": "Nie ukarano ani nie pouczono kierowcy",
    "recydywa": "Kierowca tego pojazdu popełnił wykroczenie, ale nie został niestety ukarany",
    "allowed": ["confirmed-fined", "confirmed-instructed", "confirmed-complaint", "confirmed-sm", "archived"],
    "comment": "Zgłoszenie zostało zignorowane, SM/Policja nie ustaliła sprawcy albo nie doszukała się znamion wykroczenia",
    "editable": false,
    "sendable": false
  },
  "confirmed-complaint": {
    "name": "Zażalone",
    "action": "Złożone oficjalne zażalenie",
    "recydywa": "Postępowanie względem wykroczenia kierowcy tego pojazdu zostało zaskarżone w trybie art. 56a kpw",
    "allowed": ["confirmed-fined", "confirmed-instructed", "confirmed-ignored", "archived"],
    "comment": "Złożone oficjalne zażalenie zgodnie z art. 56a kpw",
    "editable": false,
    "sendable": false
  },
  "archived": {
    "name": "W archiwum",
    "action": "Przenieś do archiwum",
    "allowed": ["confirmed", "confirmed-waiting"],
    "comment": "Zgłoszenie zostało zarchiwizowane",
    "editable": false,
    "sendable": false,
    "confirmationNeeded": true
  }
}
